import { RouterOutputs } from "utils/trpc";
import { NavigateAction } from "../../schema";
import { NextRouter } from "next/router";

type Page = RouterOutputs["pages"]["list"][number];

export async function navigateToPage(
  navigateAction: NavigateAction,
  pages: Page[],
  queryParamsData: Record<string, any>,
  router: NextRouter
) {
  const page = pages?.find((p: Page) => p.id === navigateAction.config?.pageId);
  if (!page) throw new Error("Missing page");

  if (navigateAction.config.sendQueryParams) {
    await router.push(
      { pathname: `/${page.slug}`, query: queryParamsData },
      undefined,
      {}
    );
  } else {
    await router.push({ pathname: `/${page.slug}` }, undefined, {});
  }
}
